<template>
  <b-modal
    centered
    v-if="isOpen"
    v-model="isOpen"
    cancel-disabled
    hide-footer
    :title="`Visualização do histórico do pedido - ${orderId}`"
    size="lg"
  >
    <b-row>
      <b-col cols="12">
        Lista de notificações enviada pela ClearSale à ConstrUp a respeito da
        análise de anti fraude do pedido.
      </b-col>
      <b-col cols="12" class="my-3" v-if="loading">
        <b-spinner small class="mr-2" /> Carregando...
      </b-col>
      <b-col cols="12" class="mb-5 mt-2">
        <b-table
          hover
          striped
          bordered
          show-empty
          empty-text="Não há histórico de integração para esse pedido"
          :busy="loading"
          :fields="table.headers"
          :items="table.items"
        >
        </b-table>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';

import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import makeToast from '@/mixins/makeToast';

export default {
  name: 'SeeOrderHistoryModal',
  mixins: [makeToast],
  computed: {
    ...mapState(['dadosUsuario']),
  },
  data() {
    return {
      loading: false,
      isOpen: false,
      orderId: 0,
      shortDescription: '',
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'id',
            label: 'Código',
          },
          {
            key: 'details.score',
            label: 'Score',
          },
          {
            key: 'details.status',
            label: 'Status',
          },
          {
            key: 'message',
            label: 'Mensagem',
          },
          {
            key: 'createdAt',
            label: 'Recebida em',
            formatter(value, key, item) {
              return new Date(value).toLocaleString('pt-BR');
            },
          },
        ],
        items: [],
      },
    };
  },
  watch: {
    isOpen: function () {
      if (!this.isOpen) {
        this.orderId = 0;
        this.table.items = [];
      }
    },
  },
  methods: {
    open(orderId) {
      this.isOpen = true;
      this.orderId = orderId;

      this.getOrderHistory();
    },
    close() {
      this.isOpen = false;
      this.orderId = 0;
      this.table.items = [];
    },
    async getOrderHistory() {
      if (this.loading) return;

      this.loading = true;

      const params = new URLSearchParams();
      params.append('construpUserId', this.dadosUsuario.id);
      params.append('orderId', this.orderId);

      try {
        const { data } = await shopkeeperAppApi.get(
          `/integration/anti-fraud/clearsale/order-history?${params.toString()}`
        );

        this.$set(this.table, 'items', data.data || []);
      } catch {
        this.makeToast(
          'Erro',
          `Houve um ao buscar o histórico de integração do pedido`,
          'danger'
        );
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
pre {
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  max-width: 100%;
}

pre code {
  font-family: 'Roboto Mono', monospace;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
